/**
 * @generated
 * This file was automatically generated and should not be manually edited.
 *
 * Auto-generated enum for: jobs.job_type
 *
 * To regenerate: npm run db:codegen
 * Any manual changes will be overwritten on next generation.
 */

/* eslint-disable */
// @ts-nocheck

/**
 * JobType enum representing allowed values for jobs.job_type
 */
export enum JobType {
  /** Weekly Carry Over */
  WEEKLY_CARRY_OVER = 'weekly_carry_over',
  /** System Health Check */
  SYSTEM_HEALTH_CHECK = 'system_health_check',
  /** Sync Board Templates */
  SYNC_BOARD_TEMPLATES = 'sync_board_templates',
  /** Ensure User Boards */
  ENSURE_USER_BOARDS = 'ensure_user_boards',
  /** Sync Cohorts */
  SYNC_COHORTS = 'sync_cohorts',
  /** Deadline Reminders */
  DEADLINE_REMINDERS = 'deadline_reminders',
}
